import { signOut, SignOutParams } from 'next-auth/react';
import { IDP_LOGOUT_ENDPOINT } from 'src/services/auth/constants';

export const zillowSignOut = async (options?: SignOutParams) => {
    signOut({
        callbackUrl: IDP_LOGOUT_ENDPOINT,
        ...options,
    });
};
